// Auto-generated: 71 frames of the CallToAction logo reveal animation.
// Explicit require() per frame (not require.context) so webpack's CRA
// image loader resolves each path reliably.
const frameSources: string[] = [
	require( './images/logos/animation/logo.render.mp40000.png' ),
	require( './images/logos/animation/logo.render.mp40001.png' ),
	require( './images/logos/animation/logo.render.mp40002.png' ),
	require( './images/logos/animation/logo.render.mp40003.png' ),
	require( './images/logos/animation/logo.render.mp40004.png' ),
	require( './images/logos/animation/logo.render.mp40005.png' ),
	require( './images/logos/animation/logo.render.mp40006.png' ),
	require( './images/logos/animation/logo.render.mp40007.png' ),
	require( './images/logos/animation/logo.render.mp40008.png' ),
	require( './images/logos/animation/logo.render.mp40009.png' ),
	require( './images/logos/animation/logo.render.mp40010.png' ),
	require( './images/logos/animation/logo.render.mp40011.png' ),
	require( './images/logos/animation/logo.render.mp40012.png' ),
	require( './images/logos/animation/logo.render.mp40013.png' ),
	require( './images/logos/animation/logo.render.mp40014.png' ),
	require( './images/logos/animation/logo.render.mp40015.png' ),
	require( './images/logos/animation/logo.render.mp40016.png' ),
	require( './images/logos/animation/logo.render.mp40017.png' ),
	require( './images/logos/animation/logo.render.mp40018.png' ),
	require( './images/logos/animation/logo.render.mp40019.png' ),
	require( './images/logos/animation/logo.render.mp40020.png' ),
	require( './images/logos/animation/logo.render.mp40021.png' ),
	require( './images/logos/animation/logo.render.mp40022.png' ),
	require( './images/logos/animation/logo.render.mp40023.png' ),
	require( './images/logos/animation/logo.render.mp40024.png' ),
	require( './images/logos/animation/logo.render.mp40025.png' ),
	require( './images/logos/animation/logo.render.mp40026.png' ),
	require( './images/logos/animation/logo.render.mp40027.png' ),
	require( './images/logos/animation/logo.render.mp40028.png' ),
	require( './images/logos/animation/logo.render.mp40029.png' ),
	require( './images/logos/animation/logo.render.mp40030.png' ),
	require( './images/logos/animation/logo.render.mp40031.png' ),
	require( './images/logos/animation/logo.render.mp40032.png' ),
	require( './images/logos/animation/logo.render.mp40033.png' ),
	require( './images/logos/animation/logo.render.mp40034.png' ),
	require( './images/logos/animation/logo.render.mp40035.png' ),
	require( './images/logos/animation/logo.render.mp40036.png' ),
	require( './images/logos/animation/logo.render.mp40037.png' ),
	require( './images/logos/animation/logo.render.mp40038.png' ),
	require( './images/logos/animation/logo.render.mp40039.png' ),
	require( './images/logos/animation/logo.render.mp40040.png' ),
	require( './images/logos/animation/logo.render.mp40041.png' ),
	require( './images/logos/animation/logo.render.mp40042.png' ),
	require( './images/logos/animation/logo.render.mp40043.png' ),
	require( './images/logos/animation/logo.render.mp40044.png' ),
	require( './images/logos/animation/logo.render.mp40045.png' ),
	require( './images/logos/animation/logo.render.mp40046.png' ),
	require( './images/logos/animation/logo.render.mp40047.png' ),
	require( './images/logos/animation/logo.render.mp40048.png' ),
	require( './images/logos/animation/logo.render.mp40049.png' ),
	require( './images/logos/animation/logo.render.mp40050.png' ),
	require( './images/logos/animation/logo.render.mp40051.png' ),
	require( './images/logos/animation/logo.render.mp40052.png' ),
	require( './images/logos/animation/logo.render.mp40053.png' ),
	require( './images/logos/animation/logo.render.mp40054.png' ),
	require( './images/logos/animation/logo.render.mp40055.png' ),
	require( './images/logos/animation/logo.render.mp40056.png' ),
	require( './images/logos/animation/logo.render.mp40057.png' ),
	require( './images/logos/animation/logo.render.mp40058.png' ),
	require( './images/logos/animation/logo.render.mp40059.png' ),
	require( './images/logos/animation/logo.render.mp40060.png' ),
	require( './images/logos/animation/logo.render.mp40061.png' ),
	require( './images/logos/animation/logo.render.mp40062.png' ),
	require( './images/logos/animation/logo.render.mp40063.png' ),
	require( './images/logos/animation/logo.render.mp40064.png' ),
	require( './images/logos/animation/logo.render.mp40065.png' ),
	require( './images/logos/animation/logo.render.mp40066.png' ),
	require( './images/logos/animation/logo.render.mp40067.png' ),
	require( './images/logos/animation/logo.render.mp40068.png' ),
	require( './images/logos/animation/logo.render.mp40069.png' ),
	require( './images/logos/animation/logo.render.mp40070.png' ),
]

export default frameSources
